import React from "react";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import { Button } from "../../../../../../../../../shared/Button/Button";
import { useContext } from "../../../../../context";

export const AddQuestion = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  const { blocks, isError, blockListRef } = useContext();

  const onAdd = () => {
    const newBlock = blocks.create();
    blockListRef.scrollTo(newBlock.id);
  };

  return (
    <Button size="small" onClick={onAdd} isDisabled={isError}>
      {t("action.add_question")}
    </Button>
  );
};
